var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"breadcrumbs",attrs:{"itemscope":"","itemtype":"https://schema.org/BreadcrumbList"}},_vm._l((this.data),function(item){return _c('BreadcrumbItem',{key:item.id,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }